import { z } from "zod";
import { isDecimal } from "../";

export const isCurrency = z
  .function()
  .args(z.string())
  .implement((x) => {
    return isDecimal(x, "de");
  });
